import Environment from '../common/Environment';
import Member from '../entities/Member';
import MembersJson from '../jsons/MemberJson';

export default class GetResetPassword {
  execute(member: Member): Promise<void> {
    const method: string = 'GET';
    const path: string =
      Environment.server() + '/member/resetPassword/' + member.id;

    return new Promise((resolve, reject) => {
      const request = new URL(path);

      fetch(request.toString(), {
        method,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then((response: Response) => {
          if (response.ok) {
            return response.json();
          } else {
            reject(response.status);
            return null;
          }
        })
        .then((responseJson: MembersJson) => {
          if (
            responseJson.api === undefined ||
            responseJson.api.status === undefined
          ) {
            reject('Server Error');
          } else if (responseJson.api.status === 'success') {
            resolve();
          } else {
            reject(responseJson.api.errorMessage);
          }
        })
        .catch(error => {
          console.log(error.message);
          reject(
            `通信に失敗しました。ネットワークに問題がある可能性があります。\n${error.message}`
          );
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/apis/GetResetPassword.ts